import { render } from "./colorList.vue?vue&type=template&id=4a4d3d02&scoped=true"
import script from "./colorList.vue?vue&type=script&lang=js"
export * from "./colorList.vue?vue&type=script&lang=js"

import "./colorList.vue?vue&type=style&index=0&id=4a4d3d02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a4d3d02"]])

export default __exports__